import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getLiveVideos({ payload }) {
  try {
    yield put(actions.addLiveVideoLoading());
    const result = yield call(api.getLiveVideos);
    yield put(actions.getLiveVideosSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    yield put(actions.getLiveVideosFail());
  } finally {
    yield put(actions.addLiveVideoLoading(false));
  }
}

// create
function* createLiveVideo(formData) {
  try {
    yield put(actions.addLiveVideoLoading());
    const result = yield call(api.createLiveVideo, formData.payload);
    yield put(
      actions.createLiveVideoSuccess({
        data: result.data,
      })
    );
    toast.success("Created Successfully");
    formData?.action && formData?.action();
  } catch (error) {
    yield put(actions.createLiveVideoFail());
  } finally {
    yield put(actions.addLiveVideoLoading(false));
  }
}

function* livevideoReport({ payload }) {
  try {
    yield put(actions.addLiveVideoLoading());
    const result = yield call(api.livevideoReport, payload);
    yield put(
      actions.livevideoReportSuccess({
        data: result.data?.data,
      })
    );
  } catch (error) {
    const { response, message } = error;
    toast.error(error.response);
    yield put(actions.livevideoReportFail());
  } finally {
    yield put(actions.addLiveVideoLoading(false));
  }
}

function* toggleActiveLiveVideo({ payload: id }) {
  try {
    yield put(actions.addLiveVideoLoading(true));
    const result = yield call(api.toggleActiveLiveVideo, id);
    const data =
      result.data?.live_video || result.data?.data || result.data;
    yield put(actions.toggleActiveLiveVideoSuccess({ data, id }));
    toast.success(result.data?.message || "Status updated successfully");
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update status";
    toast.error(errorMessage);
    yield put(actions.toggleActiveLiveVideoFail());
  } finally {
    yield put(actions.addLiveVideoLoading(false));
  }
}

function* updateLiveVideo(actionArg) {
  const { id, formData } = actionArg.payload || {};
  try {
    yield put(actions.addLiveVideoLoading(true));
    const result = yield call(api.updateLiveVideo, id, formData);
    const data =
      result.data?.live_video || result.data?.data || result.data;
    yield put(actions.updateLiveVideoSuccess({ data }));
    toast.success(result.data?.message || "Live video updated successfully");
    actionArg?.action && actionArg.action();
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to update live video";
    toast.error(errorMessage);
    yield put(actions.updateLiveVideoFail());
  } finally {
    yield put(actions.addLiveVideoLoading(false));
  }
}

function* deleteLiveVideo({ payload: id }) {
  try {
    yield put(actions.addLiveVideoLoading(true));
    const result = yield call(api.deleteLiveVideo, id);
    yield put(actions.deleteLiveVideoSuccess(id));
    toast.success(result.data?.message || "Live video deleted successfully");
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to delete live video";
    toast.error(errorMessage);
    yield put(actions.deleteLiveVideoFail());
  } finally {
    yield put(actions.addLiveVideoLoading(false));
  }
}

export default function* LivevideoSaga() {
  yield takeLatest(Types.GET_LIVE_VIDEOS_REQUEST, getLiveVideos);
  yield takeLatest(Types.CREATE_LIVE_VIDEO_REQUEST, createLiveVideo);
  yield takeLatest(Types.LIVE_VIDEO_REPORT_REQUEST, livevideoReport);
  yield takeLatest(Types.TOGGLE_ACTIVE_LIVE_VIDEO_REQUEST, toggleActiveLiveVideo);
  yield takeLatest(Types.UPDATE_LIVE_VIDEO_REQUEST, updateLiveVideo);
  yield takeLatest(Types.DELETE_LIVE_VIDEO_REQUEST, deleteLiveVideo);
}
